export const oilGasLogos = [
    {
        id: 1,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/BP.png",
        width: "80%"
    },
    {
        id: 2,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Cairn.png",
        width: "70%"
    },
    {
        id: 3,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/CCED.png",
        width: "50%"
    },
    {
        id: 4,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/KJO-new.jpg",
        width: "70%"
    },
    {
        id: 5,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Noble-Energy.png",
        width: "70%"
    },
    {
        id: 6,
        src: "https://piloggroup.com/img/Client%20Logos/recent-logos/Draon-oil.jpg",
        width: "70%"
    },
    {
        id: 7,
        src: "https://piloggroup.com/img/Client%20Logos/recent-logos/OQ.jpg",
        width: "70%"
    },
    {
        id: 8,
        src: "https://piloggroup.com/img/Client%20Logos/recent-logos/bapco-energies-logo.jpg",
        width: "70%"
    },
    {
        id: 9,
        src: "https://www.piloggroup.com/img/Client%20Logos/Chemicals-Refineries/Aramco.png",
        width: "70%"
    },
    {
        id: 10,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Chevron.png",
        width: "70%"
    }
];

export const travelAndTransportLogos = [
    {
        id: 1,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/BP.png",
        width: "80%",
        alt: "BP"
    },
    {
        id: 2,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Cairn.png",
        width: "70%",
        alt: "Cairn"
    },
    {
        id: 3,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/CCED.png",
        width: "50%",
        alt: "CCED"
    },
    {
        id: 4,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/KJO-new.jpg",
        width: "70%",
        alt: "KJO"
    },
    {
        id: 5,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Noble-Energy.png",
        width: "70%",
        alt: "Noble Energy"
    },
    {
        id: 6,
        src: "https://piloggroup.com/img/Client%20Logos/recent-logos/Draon-oil.jpg",
        width: "70%",
        alt: "Draon Oil"
    },
    {
        id: 7,
        src: "https://piloggroup.com/img/Client%20Logos/recent-logos/OQ.jpg",
        width: "70%",
        alt: "OQ"
    },
    {
        id: 8,
        src: "https://piloggroup.com/img/Client%20Logos/recent-logos/bapco-energies-logo.jpg",
        width: "70%",
        alt: "Bapco Energies"
    },
    {
        id: 9,
        src: "https://www.piloggroup.com/img/Client%20Logos/Chemicals-Refineries/Aramco.png",
        width: "70%",
        alt: "Aramco"
    },
    {
        id: 10,
        src: "https://www.piloggroup.com/img/Client%20Logos/Oil-Gas/Chevron.png",
        width: "70%",
        alt: "Chevron"
    }
];
